
import * as zod from "zod";

export interface Contact {
    id: number;
    firstname: string;
    lastname: string;
    email?: string;
    phoneNumber1: string;
}


export const contactSchema = zod
  .object({
    id: zod.number(),
    firstname: zod.string().min(1, "page.customers.labels.firstname-required"),
    lastname: zod.string().min(1, "page.customers.labels.lastname-required"),
    phoneNumber1: zod.string().min(1, "page.customers.labels.phoneNumber1-required"),
    email: zod
      .string()
      .email("page.customers.labels.email-validation")
      .optional(),
  });
